export const editSurvey = (state = null, action) => {
  switch (action.type) {
    case 'EDIT_SURVEY': {
      return action.payload.survey;
    }
    case 'STOP_EDITING_SURVEY': {
      return null;
    }
    default:
      return state;
  }
};
